if (process.env.NODE_ENV === 'development') {
  let url = window.location.href
  if (url.indexOf('/page/index.html') == -1) {
    window.location.href = url.replace(url, `${url}page/index.html`)
  }
}
// ---------------------以上勿刪----------------------------

// sass
import '../../sass/index/index.sass'

//FESD
import '../fesd/fesd'

// import Swiper JS
import Swiper from 'swiper/bundle'

//其他Methods
import { methods } from '../includes/_methods'

// 跑馬燈
import 'jquery.marquee';

const index = {
  banner() {

    let lazyswitch = function(cls) {
      const media = $(cls).find('[data-media]').attr('data-media');
      if (window.innerWidth > media) return 'swiper-lazy-desktop'
      else return 'swiper-lazy-media'
    };

    const bannerOptions = {
      loop: true,
      speed: 800,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 5000,
        // disableOnInteraction: false,
      },
      lazy: {
        loadPrevNext: true,
        elementClass: lazyswitch('.banner'),
      },
      on: {
        init: function () {
          methods.getSlidesCount(this)
        },
        slideChangeTransitionStart() {
          $('.banner').find('.swiper-progress').removeClass('start');

          $('nav.navbar').attr('nav-color', this.$el.find('.swiper-slide-active').attr('font-theme'));
          $('.banner .page-scroll').attr('font-theme', this.$el.find('.swiper-slide-active').attr('font-theme'));
        },
        slideChangeTransitionEnd() {
          $('.banner').find('.swiper-progress').addClass('start');
        },
      },
    }

    const banner = new Swiper('.banner .swiper-container', bannerOptions);
  },
  swiper() {

    const productItemOptions = {
      spaceBetween: 20,
      slidesPerView: 4,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      lazy: {
        loadPrevNext: true,
        checkInView: true,
      },
      on: {
        init: function () {
          methods.getSlidesCount(this)
        },
      },
    }

    const productItem = new Swiper('.product-item .swiper-container', productItemOptions);

    const articlesOptions = {
      spaceBetween: 20,
      slidesPerView: 1,
      centerInsufficientSlides: true,
      speed: 600,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      lazy: {
        loadPrevNext: true,
        checkInView: true,
      },
      navigation: {
        nextEl: '.articles .swiper-button-next',
        prevEl: '.articles .swiper-button-prev',
      },
      breakpoints: {
        // when window width is >= 1280
        1280: {
          slidesPerView: 3,
        },
        960: {
          slidesPerView: 2,
        },
      },
      on: {
        init: function () {
          methods.getSlidesCount(this)
        },
      },
    }

    const articles = new Swiper('.articles .swiper-container', articlesOptions);

  },
  //跑馬燈
  marquee() {
    const windowWidth = $(window).outerWidth(true);

    const marquee = $('.marquee-gallery');
    const wrapper = marquee.find('.marquee-wrapper');
    const container = marquee.find('.marquee-container');
    const item = marquee.find('.marquee-container');

    if (!wrapper.length) return
    if (!container.length) return
    if (!item.length) return
  
    const marqueeW = marquee.innerWidth();

    let containerW = container.innerWidth();
    const cloneTime = Math.ceil((marqueeW - containerW) / containerW) + 1

    const clone = function() {
      for (var i = 0; i < cloneTime; i++) {

        containerW = container.innerWidth();

        if (containerW < marqueeW) {
          wrapper.clone().prependTo(container);
        }
        else {
          let duration = function () {
            if (windowWidth <= 575) return 8000
            else return 20000
          }

          marquee
            .bind('beforeStarting', function () {
              marquee.addClass('marquee-active');
              _common.bLazy.revalidate();
            })
            .bind('finished', function () {
              _common.bLazy.revalidate();
            })
            .bind('resumed', function () {
              _common.bLazy.revalidate();
            })
            .marquee({
              duration: duration(),
              gap: 0,
              delayBeforeStart: 0,
              direction: 'left',
              duplicated: true,
              pauseOnHover: true,
              startVisible: true
            })
        }
      }
    };
    clone();
  },
  init() {
    index.banner();
    index.swiper();
    index.marquee();
    _common.ellipsis();
  },
}

index.init();
